import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../services/api.js";

export default function AddCustomerModal({ open, onClose, token, onSuccess }) {
  const initialForm = {
    full_name: "",
    password: "",
    customer_id: "",
    email: "",
    phone_number: "",
    residence_type: "",
    address: "",
    city: "",
    state: "",
    identity_type: "",
    identity_number: "",
    referred_by: "",
  };

  const [customerGroups, setCustomerGroups] = useState([]);

  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCustomerGroups = async () => {
      if (!open) return;

      try {
        const res = await api.get("/customer-groups", {
          headers: {
            Authorization: token,
          },
        });

        setCustomerGroups(res.data.data || []);
      } catch (err) {
        console.error("Gagal load customer groups:", err);
        setCustomerGroups([]);
      }
    };

    fetchCustomerGroups();
  }, [open, token]);

  useEffect(() => {
    if (!open) setForm(initialForm);
  }, [open]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.full_name || !form.password) {
      Swal.fire(
        "Validasi gagal",
        "Nama lengkap dan password wajib diisi",
        "warning"
      );
      return;
    }

    setLoading(true);

    try {
      const res = await api.post(
        "/customers",
        form, // <-- data langsung
        {
          headers: {
            Authorization: token,
          },
        }
      );

      const result = res.data;

      Swal.fire("Berhasil", result.message, "success");
      onSuccess?.();
      onClose();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 dark:bg-black/70">
      <div className="w-full max-w-lg rounded-xl bg-white dark:bg-gray-900 shadow-lg p-6">
        <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">
          Tambah Customer
        </h2>

        <form onSubmit={handleSubmit} className="space-y-3">
          {/* Full Name */}
          <input
            name="full_name"
            placeholder="Nama Lengkap"
            value={form.full_name}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700
              focus:ring-2 focus:ring-blue-500 outline-none"
          />

          {/* Password */}
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700
              focus:ring-2 focus:ring-blue-500 outline-none"
          />

          {/* Customer ID */}
          <input
            name="customer_id"
            placeholder="ID Pelanggan"
            value={form.customer_id}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700
              focus:ring-2 focus:ring-blue-500 outline-none"
          />

          {/* Email */}
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700"
          />

          {/* Phone */}
          <input
            name="phone_number"
            placeholder="No. Telepon"
            value={form.phone_number}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700"
          />

          {/* Residence Type */}
          <select
            name="residence_type"
            value={form.residence_type}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700"
            required
          >
            <option value="">Pilih Jenis Hunian</option>
            <option value="rumah pribadi">Rumah Pribadi</option>
            <option value="rumah kontrakan">Rumah Kontrakan</option>
            <option value="cafe">Cafe</option>
            <option value="warung">Warung</option>
            <option value="toko">Toko</option>
            <option value="kantor">Kantor</option>
            <option value="sekolah">Sekolah</option>
            <option value="kantor pemerintahan">Kantor Pemerintahan</option>
          </select>

          {/* Address */}
          <textarea
            name="address"
            placeholder="Alamat"
            value={form.address}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700"
          />

          {/* City */}
          <input
            name="city"
            placeholder="City"
            value={form.city}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700
              focus:ring-2 focus:ring-blue-500 outline-none"
          />

          {/* State */}
          <input
            name="state"
            placeholder="State"
            value={form.state}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700
              focus:ring-2 focus:ring-blue-500 outline-none"
          />

          {/* Identity Type */}
          <select
            name="identity_type"
            value={form.identity_type}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700"
          >
            <option value="">Pilih Identitas</option>
            <option value="KTP">KTP</option>
            <option value="SIM">SIM</option>
          </select>

          {/* Identity Number */}
          <input
            name="identity_number"
            placeholder="Nomor Identitas"
            value={form.identity_number}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700"
          />

          {/* Referred By */}
          {/* <input
            name="referred_by"
            placeholder="Referred By (opsional)"
            value={form.referred_by}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              border-gray-300 dark:border-gray-700"
          /> */}
          <select
            name="referred_by"
            value={form.referred_by}
            onChange={handleChange}
            className="w-full rounded-md border px-3 py-2
    bg-white dark:bg-gray-800
    text-gray-900 dark:text-gray-100
    border-gray-300 dark:border-gray-700"
          >
            <option value="">Pilih Customer Group</option>

            {customerGroups.map((group) => (
              <option key={group.id} value={group.id}>
                {group.groupname}
              </option>
            ))}
          </select>

          {/* Actions */}
          <div className="flex justify-end gap-2 pt-4">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="px-4 py-2 rounded-md border
                border-gray-300 dark:border-gray-700
                text-gray-700 dark:text-gray-300
                hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              Batal
            </button>

            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 rounded-md
                bg-blue-600 hover:bg-blue-700
                text-white font-medium"
            >
              {loading ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
